export const localtext = {
  Subtitle: "Add a temporary deputy or remove an assignment before its end date.",
  TabAddDeputy: "Add Line Manager Deputy",
  TabRemoveAssignment: "Remove Line Manager Deputy",
  Title: "Temporary Line Manager",
} as const
